import { render, staticRenderFns } from "./BlockColorSwatches.vue?vue&type=template&id=08e198be"
import script from "./BlockColorSwatches.vue?vue&type=script&lang=js"
export * from "./BlockColorSwatches.vue?vue&type=script&lang=js"
import style0 from "./BlockColorSwatches.vue?vue&type=style&index=0&id=08e198be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports